import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import 'isomorphic-fetch';
import queryString from 'query-string';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var axios = createCommonjsModule(function (module, exports) {
/* axios v0.19.0 | (c) 2019 by Matt Zabriskie */
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	var bind = __webpack_require__(3);
	var Axios = __webpack_require__(5);
	var mergeConfig = __webpack_require__(22);
	var defaults = __webpack_require__(11);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(23);
	axios.CancelToken = __webpack_require__(24);
	axios.isCancel = __webpack_require__(10);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(25);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {
	
	var bind = __webpack_require__(3);
	var isBuffer = __webpack_require__(4);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Function equal to merge with the difference being that no reference
	 * to original objects is kept.
	 *
	 * @see merge
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function deepMerge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = deepMerge(result[key], val);
	    } else if (typeof val === 'object') {
	      result[key] = deepMerge({}, val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  deepMerge: deepMerge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 3 */
/***/ (function(module, exports) {
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	var buildURL = __webpack_require__(6);
	var InterceptorManager = __webpack_require__(7);
	var dispatchRequest = __webpack_require__(8);
	var mergeConfig = __webpack_require__(22);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	  config.method = config.method ? config.method.toLowerCase() : 'get';
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	var transformData = __webpack_require__(9);
	var isCancel = __webpack_require__(10);
	var defaults = __webpack_require__(11);
	var isAbsoluteURL = __webpack_require__(20);
	var combineURLs = __webpack_require__(21);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	var normalizeHeaderName = __webpack_require__(12);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  // Only Node.JS has a process variable that is of [[Class]] process
	  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(13);
	  } else if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(13);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	var settle = __webpack_require__(14);
	var buildURL = __webpack_require__(6);
	var parseHeaders = __webpack_require__(17);
	var isURLSameOrigin = __webpack_require__(18);
	var createError = __webpack_require__(15);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(19);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {
	
	var createError = __webpack_require__(15);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {
	
	var enhanceError = __webpack_require__(16);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ }),
/* 20 */
/***/ (function(module, exports) {
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {
	
	var utils = __webpack_require__(2);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    }
	  });
	
	  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
	    if (utils.isObject(config2[prop])) {
	      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
	    } else if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (utils.isObject(config1[prop])) {
	      config[prop] = utils.deepMerge(config1[prop]);
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  utils.forEach([
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength',
	    'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken',
	    'socketPath'
	  ], function defaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  return config;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {
	
	var Cancel = __webpack_require__(23);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 25 */
/***/ (function(module, exports) {
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ })
/******/ ])
});

});

var rngBrowser = createCommonjsModule(function (module) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}
});

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

var bytesToUuid_1 = bytesToUuid;

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rngBrowser();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid_1(b);
}

var v1_1 = v1;

var environments = {
  local: {
    gx: 'http://localhost:9000/api'
  },
  dev: {
    api: 'http://10.14.136.19:8080/shs-security-services',
    gx: 'https://gx-api.shs.dev.asc.sabre.com/api'
  },
  test1: {
    api: 'https://gw-test.synxis.com',
    gx: 'https://gx-api.shs.dev.asc.sabre.com/api'
  },
  test2: {
    api: 'https://gw-test2.synxis.com',
    gx: 'https://gx-api.shs.dev.asc.sabre.com/api'
  },
  test1elab: {
    api: 'https://gw-test.sabrehospitality.com',
    sbe: 'https://ngbw-test.sabrehospitality.com',
    media: 'https://crs-test.sabrehospitality.com',
    gx: 'https://gx-api.shs.dev.asc.sabre.com/api'
  },
  test2elab: {
    api: 'https://gw-test2.sabrehospitality.com',
    sbe: 'https://ngbw-test2.sabrehospitality.com',
    media: 'https://crs-test2.sabrehospitality.com',
    gx: 'https://gx-api.shs.dev.asc.sabre.com/api'
  },
  integcert: {
    api: 'https://gw-cert.synxis.com',
    gx: 'https://gx-api.shs.cert.asc.sabre.com/api'
  },
  loadtest: {
    api: 'https://10.14.239.71'
  },
  uat: {
    api: 'https://gw-uat.synxis.com',
    sbe: 'https://ngbw-uat.synxis.com',
    media: 'https://usertest.synxis.com',
    gx: 'https://gx-api.shs.cert.asc.sabre.com/api'
  },
  euat: {
    api: 'https://sso-euat.sabrehospitality.com/shs-security-services'
  },
  ccrsprod: {
    api: 'https://services.synxis.com',
    sbe: 'https://be.synxis.com',
    media: 'https://gc.synxis.com',
    gx: 'https://gx-api.shs.prod.asc.sabre.com/api'
  },
  ccrs: {
    api: 'https://services.synxis.com',
    sbe: 'https://be.synxis.com',
    media: 'https://gc.synxis.com',
    gx: 'https://gx-api.shs.prod.asc.sabre.com/api'
  },
  ecrsprod: {
    api: 'https://services.sabrehospitality.com'
  },
  ecrs: {
    api: 'https://services.sabrehospitality.com'
  }
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _getErrorMessage = function _getErrorMessage(response) {
    return get(response, 'error_description') || get(response, 'message');
};

var fetchData = function fetchData(url, _ref) {
    var _ref$method = _ref.method,
        method = _ref$method === undefined ? 'POST' : _ref$method,
        _ref$headers = _ref.headers,
        headers = _ref$headers === undefined ? {} : _ref$headers,
        _ref$body = _ref.body,
        body = _ref$body === undefined ? false : _ref$body,
        options = _ref.options,
        _ref$env = _ref.env,
        env = _ref$env === undefined ? 'ccrsprod' : _ref$env,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'api' : _ref$type,
        signal = _ref.signal,
        urlOverride = _ref.urlOverride;

    var parsedUrl = urlOverride ? urlOverride : get(environments, [env, type]) + addQueryParams(url, method, body);

    var fetchOptions = _extends({
        signal: signal,
        method: method,
        headers: headers
    }, options);

    if (method === 'POST' || method === 'PUT') {
        fetchOptions.body = JSON.stringify(body);
    }

    return fetch(parsedUrl, fetchOptions).then(function (response) {
        if (get(response, 'status') >= 400) {
            return response.json().then(function (res) {
                return res;
            });
        }

        return response.json();
    }).then(function (response) {
        if (get(response, 'error')) {
            return {
                success: false,
                error: response.error
            };
        }
        return {
            success: true,
            body: response
        };
    }).catch(function (error) {
        return {
            success: false,
            error: _getErrorMessage(error)
        };
    });
};

var addQueryParams = function addQueryParams(url, method, body) {
    if (!isEmpty(body) && isEqual(method, 'GET')) {
        var newUrl = url.concat('?');

        return newUrl.concat(queryString.stringify(body));
    }

    return url;
};

var envUrl = "https://znwgxqy8me.execute-api.us-west-2.amazonaws.com/ccrs";

function getHotelDetails(_ref) {
    var env = _ref.env,
        hotel = _ref.hotel,
        chain = _ref.chain,
        _ref$lang = _ref.lang,
        lang = _ref$lang === undefined ? "en-US" : _ref$lang,
        _ref$primaryChannel = _ref.primaryChannel,
        primaryChannel = _ref$primaryChannel === undefined ? "WEB" : _ref$primaryChannel;

    return fetchData("/gw/partner/v1/GetHotelDetails", {
        method: "POST",
        env: env,
        headers: {
            context: "BE",
            "Content-Type": "application/json"
        },
        options: {
            credentials: "include"
        },
        body: {
            version: 1,
            Hotel: { id: hotel },
            PrimaryChannel: { code: primaryChannel },
            UserDetails: { Preferences: { Language: { code: lang } } },
            Chain: { id: chain }
        }
    });
}

function getLeadAvailability(_ref2) {
    var env = _ref2.env,
        hotels = _ref2.hotels,
        chain = _ref2.chain,
        _ref2$adults = _ref2.adults,
        adults = _ref2$adults === undefined ? 1 : _ref2$adults,
        _ref2$children = _ref2.children,
        children = _ref2$children === undefined ? 0 : _ref2$children,
        _ref2$lang = _ref2.lang,
        _ref2$accessCode = _ref2.accessCode,
        accessCode = _ref2$accessCode === undefined ? {} : _ref2$accessCode,
        _ref2$primaryChannel = _ref2.primaryChannel,
        primaryChannel = _ref2$primaryChannel === undefined ? "WEB" : _ref2$primaryChannel,
        _ref2$secondaryChanne = _ref2.secondaryChannel,
        secondaryChannel = _ref2$secondaryChanne === undefined ? "GC" : _ref2$secondaryChanne,
        _ref2$rooms = _ref2.rooms,
        rooms = _ref2$rooms === undefined ? 1 : _ref2$rooms,
        arrival = _ref2.arrival,
        departure = _ref2.departure;

    return fetchData("/gw/product/v1/getLeadAvailability", {
        method: "POST",
        env: env,
        headers: {
            context: "BE",
            "Content-Type": "application/json"
        },
        options: {
            credentials: "include"
        },
        body: {
            Version: 1,
            Criterion: {
                ArrivalDate: arrival,
                departureDate: departure,
                NumRooms: rooms,
                ChannelList: {
                    PrimaryChannel: { Code: primaryChannel },
                    SecondaryChannel: { Code: secondaryChannel }
                },
                AccessCode: accessCode,
                RoomStay: {
                    GuestCount: [{ AgeQualifyingCode: "Adult", NumGuests: adults }, { AgeQualifyingCode: "Child", NumGuests: children }],
                    RateFilterList: []
                }
            },
            Chain: { Id: chain },
            HotelList: hotels.map(function (hotel) {
                return {
                    Id: hotel
                };
            })
        }
    });
}

function getHotels(_ref3) {
    var env = _ref3.env,
        chain = _ref3.chain,
        _ref3$primaryChannel = _ref3.primaryChannel,
        primaryChannel = _ref3$primaryChannel === undefined ? "WEB" : _ref3$primaryChannel,
        _ref3$secondaryChanne = _ref3.secondaryChannel,
        secondaryChannel = _ref3$secondaryChanne === undefined ? "GC" : _ref3$secondaryChanne,
        _ref3$sortOrder = _ref3.sortOrder,
        sortOrder = _ref3$sortOrder === undefined ? "random" : _ref3$sortOrder,
        _ref3$size = _ref3.size,
        size = _ref3$size === undefined ? 50 : _ref3$size,
        _ref3$start = _ref3.start,
        start = _ref3$start === undefined ? 0 : _ref3$start,
        brands = _ref3.brands,
        destination = _ref3.destination,
        distance = _ref3.distance;

    return fetchData("/gw/partner/v1/QueryHotelList", {
        method: "POST",
        env: env,
        headers: {
            context: "BE",
            "Content-Type": "application/json"
        },
        options: {
            credentials: "include"
        },
        body: {
            version: "1",
            ChannelList: {
                PrimaryChannel: { code: primaryChannel },
                SecondaryChannel: { code: secondaryChannel }
            },
            Paging: { Size: size, Start: start },
            Query: {
                SearchCriteria: _extends({}, brands ? {
                    BrandList: brands //[{id: ''}]
                } : {}, destination ? {
                    Destination: {
                        id: destination
                    }
                } : {}, distance ? {
                    Distance: {
                        Latitude: distance.latitude,
                        Longitude: distance.longitude,
                        limit: distance.distanceLimit,
                        unit: distance.distanceUnit
                    }
                } : {}, {
                    source: "General",
                    Chain: { id: chain },
                    Channel: [{ Code: primaryChannel }]
                }),
                SortCriteria: _extends({
                    sortOrder: sortOrder
                }, distance ? {
                    Distance: ["AltAvailabilityBrandThenByDistance", "BrandThenByDistance", "ByDistance"].includes(distance.sortOrder) ? {
                        Latitude: distance.latitude,
                        Longitude: distance.longitude
                    } : undefined
                } : {})
            }
        }
    });
}

function getSession(env) {
    return fetchData("/gw/api/session", {
        method: "POST",
        env: env,
        headers: {
            context: "BE",
            "Content-Type": "application/json"
        },
        options: {
            credentials: "include"
        },
        body: {}
    });
}

function checkSession(env) {
    return fetchData("/gw/api/session", {
        method: "GET",
        env: env,
        headers: {
            context: "BE"
        },
        options: {
            credentials: "include"
        }
    });
}

function getProducts(_ref4) {
    var env = _ref4.env,
        chain = _ref4.chain,
        hotel = _ref4.hotel,
        rooms = _ref4.rooms,
        arrival = _ref4.arrival,
        departure = _ref4.departure,
        adults = _ref4.adults,
        children = _ref4.children,
        lang = _ref4.lang,
        _ref4$primaryChannel = _ref4.primaryChannel,
        primaryChannel = _ref4$primaryChannel === undefined ? "WEB" : _ref4$primaryChannel,
        _ref4$secondaryChanne = _ref4.secondaryChannel,
        secondaryChannel = _ref4$secondaryChanne === undefined ? "GC" : _ref4$secondaryChanne,
        _ref4$accessCode = _ref4.accessCode,
        accessCode = _ref4$accessCode === undefined ? {} : _ref4$accessCode,
        _ref4$extraParams = _ref4.extraParams,
        extraParams = _ref4$extraParams === undefined ? {} : _ref4$extraParams,
        _ref4$coupon = _ref4.coupon,
        coupon = _ref4$coupon === undefined ? null : _ref4$coupon,
        _ref4$onlyCheckReques = _ref4.onlyCheckRequested,
        onlyCheckRequested = _ref4$onlyCheckReques === undefined ? false : _ref4$onlyCheckReques;

    return fetchData("/gw/product/v1/getProductAvailability", {
        method: "POST",
        env: env,
        headers: {
            context: "BE",
            "Content-Type": "application/json"
        },
        options: {
            credentials: "include"
        },
        body: {
            Paging: { Size: 50 },
            ProductAvailabilityQuery: _extends({
                OnlyCheckRequested: onlyCheckRequested,
                ReturnFullContentDetails: true,
                Chain: { Id: chain },
                Hotel: { Id: hotel },
                AccessCode: accessCode,
                Currency: { currencyCode: "USD" },
                ChannelList: {
                    PrimaryChannel: { Code: primaryChannel },
                    SecondaryChannel: { Code: secondaryChannel }
                },
                CouponOfferCode: coupon,
                NumRooms: rooms,
                ProductSortingType: "RoomsThenRates",
                RoomStay: {
                    EndDate: departure,
                    StartDate: arrival,
                    GuestCount: [{ AgeQualifyingCode: "Adult", NumGuests: adults }, {
                        AgeQualifyingCode: "Child",
                        NumGuests: children,
                        Ages: []
                    }],
                    RateFilterList: [{ Code: "CHAIN" }]
                }
            }, extraParams),
            UserDetails: { Preferences: { Language: { code: lang } } },
            Version: 1
        }
    });
}

function getAvailabilityCalendar(_ref5) {
    var env = _ref5.env,
        chain = _ref5.chain,
        hotel = _ref5.hotel,
        rooms = _ref5.rooms,
        arrival = _ref5.arrival,
        departure = _ref5.departure,
        adults = _ref5.adults,
        children = _ref5.children,
        lengthOfStay = _ref5.lengthOfStay,
        accessCodeType = _ref5.accessCodeType,
        accessCode = _ref5.accessCode,
        _ref5$primaryChannel = _ref5.primaryChannel,
        primaryChannel = _ref5$primaryChannel === undefined ? "WEB" : _ref5$primaryChannel,
        _ref5$secondaryChanne = _ref5.secondaryChannel,
        secondaryChannel = _ref5$secondaryChanne === undefined ? "GC" : _ref5$secondaryChanne,
        _ref5$extraParams = _ref5.extraParams,
        extraParams = _ref5$extraParams === undefined ? {} : _ref5$extraParams,
        _ref5$extraRoomStayPa = _ref5.extraRoomStayParams,
        extraRoomStayParams = _ref5$extraRoomStayPa === undefined ? {} : _ref5$extraRoomStayPa,
        url = _ref5.url;

    return fetchData("/gw/product/v1/getAvailabilityCalendar", {
        method: "POST",
        env: env,
        headers: {
            context: "BE",
            "Content-Type": "application/json"
        },
        options: {
            credentials: "include"
        },
        body: {
            CalendarAvailabilityQuery: _extends({}, accessCodeType && accessCode ? {
                AccessCode: {
                    type: accessCodeType,
                    value: accessCode
                }
            } : {}, {
                EndDate: departure,
                LengthOfStay: lengthOfStay,
                StartDate: arrival,
                ChannelList: {
                    PrimaryChannel: {
                        Code: primaryChannel
                    },
                    SecondaryChannel: {
                        Code: secondaryChannel
                    }
                },
                NumRooms: rooms,
                RoomStay: _extends({
                    GuestCount: [{
                        AgeQualifyingCode: "Adult",
                        NumGuests: adults
                    }, {
                        AgeQualifyingCode: "Child",
                        NumGuests: children
                    }]
                }, extraRoomStayParams)
            }, extraParams),
            Chain: {
                Id: chain
            },
            Hotel: {
                Id: hotel
            },
            Version: 1
        },
        urlOverride: url
    });
}

function getPackages(_ref6) {
    var currency = _ref6.currency,
        env = _ref6.env,
        chain = _ref6.chain,
        hotel = _ref6.hotel,
        arrival = _ref6.arrival,
        departure = _ref6.departure,
        rate = _ref6.rate,
        room = _ref6.room,
        _ref6$lang = _ref6.lang,
        lang = _ref6$lang === undefined ? "en-US" : _ref6$lang,
        _ref6$primaryChannel = _ref6.primaryChannel,
        primaryChannel = _ref6$primaryChannel === undefined ? "WEB" : _ref6$primaryChannel,
        _ref6$secondaryChanne = _ref6.secondaryChannel,
        secondaryChannel = _ref6$secondaryChanne === undefined ? "GC" : _ref6$secondaryChanne,
        _ref6$maxAddonsToFetc = _ref6.maxAddonsToFetch,
        maxAddonsToFetch = _ref6$maxAddonsToFetc === undefined ? 50 : _ref6$maxAddonsToFetc;

    return fetchData("/gw/product/v1/GetPackageAvailability", {
        method: "POST",
        env: env,
        headers: {
            context: "BE",
            "Content-Type": "application/json"
        },
        options: {
            credentials: "include"
        },
        body: {
            Paging: {
                Size: maxAddonsToFetch
            },
            PackageAvailabilityQuery: _extends({
                Chain: { id: chain },
                ChannelList: {
                    PrimaryChannel: { code: primaryChannel },
                    SecondaryChannel: { code: secondaryChannel }
                },
                Hotel: { id: hotel },
                Rate: { code: rate },
                Room: { code: room },
                TimeFrame: { endDate: departure, startDate: arrival }
            }, currency ? {
                Currency: {
                    currencyCode: currency
                }
            } : {}),
            UserDetails: { Preferences: { Language: { code: lang } } }
        }
    });
}

function getListOfLoyaltyPrograms(_ref7) {
    var env = _ref7.env,
        chain = _ref7.chain,
        _ref7$context = _ref7.context,
        context = _ref7$context === undefined ? "BE" : _ref7$context,
        token = _ref7.token;

    return fetchData("/frontman/getLoyaltyPrograms", {
        method: "POST",
        env: env,
        headers: {
            context: context,
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
        },
        body: {
            chainId: chain
        }
    });
}

function getWidgetAvailabilityCalendar(_ref8) {
    var env = _ref8.env,
        chain = _ref8.chain,
        hotel = _ref8.hotel,
        rooms = _ref8.rooms,
        arrival = _ref8.arrival,
        departure = _ref8.departure,
        adults = _ref8.adults,
        children = _ref8.children,
        lengthOfStay = _ref8.lengthOfStay,
        accessCodeType = _ref8.accessCodeType,
        accessCode = _ref8.accessCode,
        _ref8$primaryChannel = _ref8.primaryChannel,
        primaryChannel = _ref8$primaryChannel === undefined ? "WEB" : _ref8$primaryChannel,
        _ref8$secondaryChanne = _ref8.secondaryChannel,
        secondaryChannel = _ref8$secondaryChanne === undefined ? "GC" : _ref8$secondaryChanne,
        _ref8$extraParams = _ref8.extraParams,
        extraParams = _ref8$extraParams === undefined ? {} : _ref8$extraParams,
        _ref8$extraRoomStayPa = _ref8.extraRoomStayParams,
        extraRoomStayParams = _ref8$extraRoomStayPa === undefined ? {} : _ref8$extraRoomStayPa,
        url = _ref8.url,
        token = _ref8.token,
        api = _ref8.api,
        widget = _ref8.widget;

    return axios.post(envUrl + "/crs/" + api, {
        method: "POST",
        headers: {
            activityid: v1_1(),
            context: "BE",
            "Content-Type": "application/json"
        },
        body: {
            CalendarAvailabilityQuery: _extends({}, accessCodeType && accessCode ? {
                AccessCode: {
                    type: accessCodeType,
                    value: accessCode
                }
            } : {}, {
                EndDate: departure,
                LengthOfStay: lengthOfStay,
                StartDate: arrival,
                ChannelList: {
                    PrimaryChannel: {
                        Code: primaryChannel
                    },
                    SecondaryChannel: {
                        Code: secondaryChannel
                    }
                },
                NumRooms: rooms,
                RoomStay: _extends({
                    GuestCount: [{
                        AgeQualifyingCode: "Adult",
                        NumGuests: adults
                    }, {
                        AgeQualifyingCode: "Child",
                        NumGuests: children
                    }]
                }, extraRoomStayParams)
            }, extraParams),
            Chain: {
                Id: chain
            },
            Hotel: {
                Id: hotel
            },
            Version: 1
        },
        api: "getAvailabilityCalendar",
        widget: widget,
        env: env,
        chain: chain,
        hotel: hotel
    }, {
        headers: _extends({
            "Content-Type": "application/json"
        }, token ? {
            Authorization: token
        } : {})
    });
}

function getWidgetHotels(_ref9) {
    var _ref9$primaryChannel = _ref9.primaryChannel,
        primaryChannel = _ref9$primaryChannel === undefined ? "WEB" : _ref9$primaryChannel,
        _ref9$secondaryChanne = _ref9.secondaryChannel,
        secondaryChannel = _ref9$secondaryChanne === undefined ? "GC" : _ref9$secondaryChanne,
        _ref9$sortOrder = _ref9.sortOrder,
        sortOrder = _ref9$sortOrder === undefined ? "random" : _ref9$sortOrder,
        _ref9$size = _ref9.size,
        size = _ref9$size === undefined ? 50 : _ref9$size,
        _ref9$start = _ref9.start,
        start = _ref9$start === undefined ? 0 : _ref9$start,
        brands = _ref9.brands,
        destination = _ref9.destination,
        distance = _ref9.distance,
        env = _ref9.env,
        token = _ref9.token,
        api = _ref9.api,
        widget = _ref9.widget,
        chain = _ref9.chain;

    return axios.post(envUrl + "/crs/" + api, {
        method: "POST",
        headers: {
            activityid: v1_1(),
            context: "BE",
            "Content-Type": "application/json"
        },
        body: {
            version: "1",
            ChannelList: {
                PrimaryChannel: { code: primaryChannel },
                SecondaryChannel: { code: secondaryChannel }
            },
            Paging: { Size: size, Start: start },
            Query: {
                SearchCriteria: _extends({}, brands ? {
                    BrandList: brands //[{id: ''}]
                } : {}, destination ? {
                    Destination: {
                        id: destination
                    }
                } : {}, distance ? {
                    Distance: {
                        Latitude: distance.latitude,
                        Longitude: distance.longitude,
                        limit: distance.distanceLimit,
                        unit: distance.distanceUnit
                    }
                } : {}, {
                    source: "General",
                    Channel: [{ Code: primaryChannel }]
                }),
                SortCriteria: _extends({
                    sortOrder: sortOrder
                }, distance ? {
                    Distance: ["AltAvailabilityBrandThenByDistance", "BrandThenByDistance", "ByDistance"].includes(distance.sortOrder) ? {
                        Latitude: distance.latitude,
                        Longitude: distance.longitude
                    } : undefined
                } : {})
            }
        },
        api: "getHotelDetails",
        widget: widget,
        env: env,
        chain: chain
    });
}

function getWidgetHotelDetails(_ref10) {
    var chain = _ref10.chain,
        _ref10$lang = _ref10.lang,
        lang = _ref10$lang === undefined ? "en-US" : _ref10$lang,
        _ref10$primaryChannel = _ref10.primaryChannel,
        primaryChannel = _ref10$primaryChannel === undefined ? "WEB" : _ref10$primaryChannel,
        hotel = _ref10.hotel,
        env = _ref10.env,
        token = _ref10.token,
        api = _ref10.api,
        widget = _ref10.widget;

    return axios.post(envUrl + "/crs/" + api, {
        method: "POST",
        headers: {
            activityid: v1_1(),
            context: "BE",
            "Content-Type": "application/json"
        },
        body: {
            version: 1,
            Hotel: { id: hotel },
            PrimaryChannel: { code: primaryChannel },
            UserDetails: { Preferences: { Language: { code: lang } } },
            Chain: { id: chain }
        },
        api: "getHotelDetails",
        widget: widget,
        env: env,
        hotel: hotel,
        chain: chain
    });
}

function fetchReservations(_ref) {
  var env = _ref.env,
      params = _ref.params,
      token = _ref.token,
      headers = _ref.headers;

  return fetchData('/arrivalsDepartures/reservations', {
    method: 'POST',
    env: env,
    headers: _extends({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Environment: env
    }, headers),
    body: _extends({}, params),
    type: 'gx'
  });
}

function downloadReservations(_ref2) {
  var env = _ref2.env,
      params = _ref2.params,
      token = _ref2.token,
      headers = _ref2.headers;

  return fetchData('/arrivalsDepartures/downloadReservations', {
    method: 'POST',
    env: env,
    headers: _extends({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Environment: env
    }, headers),
    body: _extends({}, params),
    type: 'gx'
  });
}

var commonParams = function commonParams(_ref) {
    var env = _ref.env,
        token = _ref.token,
        headers = _ref.headers,
        signal = _ref.signal;
    return {
        signal: signal,
        env: env,
        headers: _extends({
            Authorization: 'Bearer ' + token,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Environment: env
        }, headers),
        type: 'gx'
    };
};

var getProfile = function getProfile(_ref2) {
    var env = _ref2.env,
        token = _ref2.token,
        headers = _ref2.headers,
        chainId = _ref2.chainId,
        profileId = _ref2.profileId,
        includedFields = _ref2.includedFields,
        signal = _ref2.signal;

    return fetchData('/profiles/getProfile', _extends({
        method: 'POST',
        body: {
            profileId: profileId,
            chainId: chainId,
            includedFields: includedFields
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var deleteProfile = function deleteProfile(_ref3) {
    var env = _ref3.env,
        token = _ref3.token,
        headers = _ref3.headers,
        chainId = _ref3.chainId,
        profileToUpdate = _ref3.profileToUpdate,
        signal = _ref3.signal;

    return fetchData('/profiles/deleteProfile', _extends({
        method: 'POST',
        body: {
            profileToUpdate: profileToUpdate,
            chainId: chainId
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var updateProfile = function updateProfile(_ref4) {
    var env = _ref4.env,
        token = _ref4.token,
        headers = _ref4.headers,
        chainId = _ref4.chainId,
        profileToUpdate = _ref4.profileToUpdate,
        signal = _ref4.signal;

    return fetchData('/profiles/updateProfile', _extends({
        method: 'POST',
        body: {
            chainId: chainId,
            profileToUpdate: profileToUpdate
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getProfileDuplicates = function getProfileDuplicates(_ref5) {
    var env = _ref5.env,
        token = _ref5.token,
        headers = _ref5.headers,
        chainId = _ref5.chainId,
        profile = _ref5.profile,
        signal = _ref5.signal;

    return fetchData('/matchAndMerge/getProfileDuplicates', _extends({
        method: 'POST',
        body: {
            chainId: chainId, profile: profile
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getPreferencesList = function getPreferencesList(_ref6) {
    var env = _ref6.env,
        token = _ref6.token,
        headers = _ref6.headers,
        chainId = _ref6.chainId,
        profileId = _ref6.profileId,
        signal = _ref6.signal;

    return fetchData('/preferences/getPreferencesList', _extends({
        method: 'GET',
        body: {
            profileId: profileId,
            chainId: chainId
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getReservations = function getReservations(_ref7) {
    var env = _ref7.env,
        token = _ref7.token,
        headers = _ref7.headers,
        chainId = _ref7.chainId,
        profileId = _ref7.profileId,
        signal = _ref7.signal;

    return fetchData('/reservations/getReservations', _extends({
        method: 'POST',
        body: {
            profileId: profileId,
            chainId: chainId
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getBlacklistReason = function getBlacklistReason(_ref8) {
    var env = _ref8.env,
        token = _ref8.token,
        headers = _ref8.headers,
        chainId = _ref8.chainId,
        signal = _ref8.signal;

    return fetchData('/frontman/getBlacklistReason', _extends({
        method: 'GET',
        body: {
            chainId: chainId
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getVIPLevels = function getVIPLevels(_ref9) {
    var env = _ref9.env,
        token = _ref9.token,
        headers = _ref9.headers,
        chainId = _ref9.chainId,
        signal = _ref9.signal;

    return fetchData('/frontman/getVIPLevels', _extends({
        method: 'GET',
        body: {
            chainId: chainId
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getPrefixes = function getPrefixes(_ref10) {
    var env = _ref10.env,
        token = _ref10.token,
        headers = _ref10.headers,
        signal = _ref10.signal;

    return fetchData('/frontman/getPrefixes', _extends({
        method: 'GET'
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getCountriesList = function getCountriesList(_ref11) {
    var env = _ref11.env,
        token = _ref11.token,
        headers = _ref11.headers,
        signal = _ref11.signal;

    return fetchData('/frontman/getCountriesList', _extends({
        method: 'GET'
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getLanguages = function getLanguages(_ref12) {
    var env = _ref12.env,
        token = _ref12.token,
        headers = _ref12.headers,
        signal = _ref12.signal;

    return fetchData('/frontman/getLanguages', _extends({
        method: 'GET'
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getCurrencies = function getCurrencies(_ref13) {
    var env = _ref13.env,
        token = _ref13.token,
        headers = _ref13.headers,
        signal = _ref13.signal;

    return fetchData('/frontman/getCurrencies', _extends({
        method: 'GET'
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var getActiveConfiguration = function getActiveConfiguration(_ref14) {
    var env = _ref14.env,
        token = _ref14.token,
        headers = _ref14.headers,
        vendorType = _ref14.vendorType,
        vendorCode = _ref14.vendorCode,
        signal = _ref14.signal;

    return fetchData('/rfm/getActiveConfiguration', _extends({
        method: 'GET',
        body: {
            vendorType: vendorType,
            vendorCode: vendorCode
        }
    }, commonParams({ env: env, token: token, headers: headers, signal: signal })));
};

var currencies = {
    "AED": {
        "symbol": "AED",
        "code": "AED",
        "symbol_native": "\u062F.\u0625.\u200F",
        "decimal_digits": 2,
        "rounding": 0.0
    },
    "AFN": { "symbol": "AFN", "code": "AFN", "symbol_native": "؋", "decimal_digits": 0 },
    "ALL": { "symbol": "ALL", "code": "ALL", "symbol_native": "Lekë", "decimal_digits": 0 },
    "AMD": { "symbol": "AMD", "code": "AMD", "symbol_native": "֏", "decimal_digits": 0 },
    "ANG": { "symbol": "ANG", "code": "ANG", "symbol_native": "NAf.", "decimal_digits": 2 },
    "AOA": { "symbol": "AOA", "code": "AOA", "symbol_native": "Kz", "decimal_digits": 2 },
    "ARS": { "symbol": "ARS", "code": "ARS", "symbol_native": "$", "decimal_digits": 2 },
    "AUD": { "symbol": "AUD", "code": "AUD", "symbol_native": "$", "decimal_digits": 2 },
    "AWG": { "symbol": "AWG", "code": "AWG", "symbol_native": "Afl.", "decimal_digits": 2 },
    "AZN": { "symbol": "AZN", "code": "AZN", "symbol_native": "\u20BC", "decimal_digits": 2 },
    "BAM": { "symbol": "BAM", "code": "BAM", "symbol_native": "КМ", "decimal_digits": 2 },
    "BBD": { "symbol": "BBD", "code": "BBD", "symbol_native": "$", "decimal_digits": 2 },
    "BDT": { "symbol": "BDT", "code": "BDT", "symbol_native": "৳", "decimal_digits": 2 },
    "BGN": { "symbol": "BGN", "code": "BGN", "symbol_native": "лв.", "decimal_digits": 2 },
    "BHD": { "symbol": "BHD", "code": "BHD", "symbol_native": "\u062F.\u0628.\u200F", "decimal_digits": 3 },
    "BIF": { "symbol": "BIF", "code": "BIF", "symbol_native": "FBu", "decimal_digits": 0 },
    "BMD": { "symbol": "BMD", "code": "BMD", "symbol_native": "$", "decimal_digits": 2 },
    "BND": { "symbol": "BND", "code": "BND", "symbol_native": "$", "decimal_digits": 2 },
    "BOB": { "symbol": "BOB", "code": "BOB", "symbol_native": "Bs", "decimal_digits": 2 },
    "BOV": { "symbol": "BOV", "code": "BOV", "symbol_native": "BOV", "decimal_digits": 2 },
    "BRL": { "symbol": "R$", "code": "BRL", "symbol_native": "R$", "decimal_digits": 2 },
    "BSD": { "symbol": "BSD", "code": "BSD", "symbol_native": "$", "decimal_digits": 2 },
    "BTN": { "symbol": "BTN", "code": "BTN", "symbol_native": "Nu.", "decimal_digits": 2 },
    "BWP": { "symbol": "BWP", "code": "BWP", "symbol_native": "P", "decimal_digits": 2 },
    "BYN": { "symbol": "BYN", "code": "BYN", "symbol_native": "Br", "decimal_digits": 2 },
    "BZD": { "symbol": "BZD", "code": "BZD", "symbol_native": "$", "decimal_digits": 2 },
    "CAD": { "symbol": "CAD", "code": "CAD", "symbol_native": "$", "decimal_digits": 2 },
    "CDF": { "symbol": "CDF", "code": "CDF", "symbol_native": "FC", "decimal_digits": 2 },
    "CHE": { "symbol": "CHE", "code": "CHE", "symbol_native": "CHE", "decimal_digits": 2 },
    "CHF": { "symbol": "CHF", "code": "CHF", "symbol_native": "CHF", "decimal_digits": 2 },
    "CHW": { "symbol": "CHW", "code": "CHW", "symbol_native": "CHW", "decimal_digits": 2 },
    "CLF": { "symbol": "CLF", "code": "CLF", "symbol_native": "CLF", "decimal_digits": 4 },
    "CLP": { "symbol": "CLP", "code": "CLP", "symbol_native": "$", "decimal_digits": 0 },
    "CNH": { "symbol": "CNH", "code": "CNH", "symbol_native": "CNH", "decimal_digits": 2 },
    "CNY": { "symbol": "CNY", "code": "CNY", "symbol_native": "¥", "decimal_digits": 2 },
    "COP": { "symbol": "COP", "code": "COP", "symbol_native": "$", "decimal_digits": 0 },
    "COU": { "symbol": "COU", "code": "COU", "symbol_native": "COU", "decimal_digits": 2 },
    "CRC": { "symbol": "CRC", "code": "CRC", "symbol_native": "\u20A1", "decimal_digits": 2 },
    "CUC": { "symbol": "CUC", "code": "CUC", "symbol_native": "CUC", "decimal_digits": 2 },
    "CUP": { "symbol": "CUP", "code": "CUP", "symbol_native": "$", "decimal_digits": 2 },
    "CVE": { "symbol": "CVE", "code": "CVE", "symbol_native": "\u200B", "decimal_digits": 2 },
    "CZK": { "symbol": "CZK", "code": "CZK", "symbol_native": "Kč", "decimal_digits": 2 },
    "DJF": { "symbol": "DJF", "code": "DJF", "symbol_native": "Fdj", "decimal_digits": 0 },
    "DKK": { "symbol": "DKK", "code": "DKK", "symbol_native": "kr.", "decimal_digits": 2 },
    "DOP": { "symbol": "DOP", "code": "DOP", "symbol_native": "RD$", "decimal_digits": 2 },
    "DZD": { "symbol": "DZD", "code": "DZD", "symbol_native": "\u062F.\u062C.\u200F", "decimal_digits": 2 },
    "EGP": { "symbol": "EGP", "code": "EGP", "symbol_native": "\u062C.\u0645.\u200F", "decimal_digits": 2 },
    "ERN": { "symbol": "ERN", "code": "ERN", "symbol_native": "Nfk", "decimal_digits": 2 },
    "ETB": { "symbol": "ETB", "code": "ETB", "symbol_native": "ብር", "decimal_digits": 2 },
    "EUR": { "symbol": "\u20AC", "code": "EUR", "symbol_native": "\u20AC", "decimal_digits": 2 },
    "FJD": { "symbol": "FJD", "code": "FJD", "symbol_native": "$", "decimal_digits": 2 },
    "FKP": { "symbol": "FKP", "code": "FKP", "symbol_native": "£", "decimal_digits": 2 },
    "GBP": { "symbol": "GBP", "code": "GBP", "symbol_native": "£", "decimal_digits": 2 },
    "GEL": { "symbol": "GEL", "code": "GEL", "symbol_native": "\u20BE", "decimal_digits": 2 },
    "GHS": { "symbol": "GHS", "code": "GHS", "symbol_native": "GH\u20B5", "decimal_digits": 2 },
    "GIP": { "symbol": "GIP", "code": "GIP", "symbol_native": "£", "decimal_digits": 2 },
    "GMD": { "symbol": "GMD", "code": "GMD", "symbol_native": "D", "decimal_digits": 2 },
    "GNF": { "symbol": "GNF", "code": "GNF", "symbol_native": "FG", "decimal_digits": 0 },
    "GTQ": { "symbol": "GTQ", "code": "GTQ", "symbol_native": "Q", "decimal_digits": 2 },
    "GYD": { "symbol": "GYD", "code": "GYD", "symbol_native": "$", "decimal_digits": 0 },
    "HKD": { "symbol": "HKD", "code": "HKD", "symbol_native": "HK$", "decimal_digits": 2 },
    "HNL": { "symbol": "HNL", "code": "HNL", "symbol_native": "L", "decimal_digits": 2 },
    "HRK": { "symbol": "HRK", "code": "HRK", "symbol_native": "HRK", "decimal_digits": 2 },
    "HTG": { "symbol": "HTG", "code": "HTG", "symbol_native": "G", "decimal_digits": 2 },
    "HUF": { "symbol": "HUF", "code": "HUF", "symbol_native": "Ft", "decimal_digits": 2 },
    "IDR": { "symbol": "IDR", "code": "IDR", "symbol_native": "Rp", "decimal_digits": 0 },
    "ILS": { "symbol": "ILS", "code": "ILS", "symbol_native": "\u20AA", "decimal_digits": 2 },
    "INR": { "symbol": "INR", "code": "INR", "symbol_native": "\u20B9", "decimal_digits": 2 },
    "IQD": { "symbol": "IQD", "code": "IQD", "symbol_native": "\u062F.\u0639.\u200F", "decimal_digits": 0 },
    "IRR": { "symbol": "IRR", "code": "IRR", "symbol_native": "IRR", "decimal_digits": 0 },
    "ISK": { "symbol": "ISK", "code": "ISK", "symbol_native": "ISK", "decimal_digits": 0 },
    "JMD": { "symbol": "JMD", "code": "JMD", "symbol_native": "$", "decimal_digits": 2 },
    "JOD": { "symbol": "JOD", "code": "JOD", "symbol_native": "\u062F.\u0623.\u200F", "decimal_digits": 3 },
    "JPY": { "symbol": "JPY", "code": "JPY", "symbol_native": "￥", "decimal_digits": 0 },
    "KES": { "symbol": "KES", "code": "KES", "symbol_native": "Ksh", "decimal_digits": 2 },
    "KGS": { "symbol": "KGS", "code": "KGS", "symbol_native": "сом", "decimal_digits": 2 },
    "KHR": { "symbol": "KHR", "code": "KHR", "symbol_native": "៛", "decimal_digits": 2 },
    "KMF": { "symbol": "KMF", "code": "KMF", "symbol_native": "CF", "decimal_digits": 0 },
    "KPW": { "symbol": "KPW", "code": "KPW", "symbol_native": "KPW", "decimal_digits": 0 },
    "KRW": { "symbol": "KRW", "code": "KRW", "symbol_native": "\u20A9", "decimal_digits": 0 },
    "KWD": { "symbol": "KWD", "code": "KWD", "symbol_native": "\u062F.\u0643.\u200F", "decimal_digits": 3 },
    "KYD": { "symbol": "KYD", "code": "KYD", "symbol_native": "$", "decimal_digits": 2 },
    "KZT": { "symbol": "KZT", "code": "KZT", "symbol_native": "\u20B8", "decimal_digits": 2 },
    "LAK": { "symbol": "LAK", "code": "LAK", "symbol_native": "\u20AD", "decimal_digits": 0 },
    "LBP": { "symbol": "LBP", "code": "LBP", "symbol_native": "\u0644.\u0644.\u200F", "decimal_digits": 0 },
    "LKR": { "symbol": "LKR", "code": "LKR", "symbol_native": "රු.", "decimal_digits": 2 },
    "LRD": { "symbol": "LRD", "code": "LRD", "symbol_native": "$", "decimal_digits": 2 },
    "LSL": { "symbol": "LSL", "code": "LSL", "symbol_native": "LSL", "decimal_digits": 2 },
    "LYD": { "symbol": "LYD", "code": "LYD", "symbol_native": "\u062F.\u0644.\u200F", "decimal_digits": 3 },
    "MAD": { "symbol": "MAD", "code": "MAD", "symbol_native": "\u062F.\u0645.\u200F", "decimal_digits": 2 },
    "MDL": { "symbol": "MDL", "code": "MDL", "symbol_native": "L", "decimal_digits": 2 },
    "MGA": { "symbol": "MGA", "code": "MGA", "symbol_native": "Ar", "decimal_digits": 0 },
    "MKD": { "symbol": "MKD", "code": "MKD", "symbol_native": "ден", "decimal_digits": 2 },
    "MMK": { "symbol": "MMK", "code": "MMK", "symbol_native": "K", "decimal_digits": 0 },
    "MNT": { "symbol": "MNT", "code": "MNT", "symbol_native": "\u20AE", "decimal_digits": 0 },
    "MOP": { "symbol": "MOP", "code": "MOP", "symbol_native": "MOP$", "decimal_digits": 2 },
    "MRO": { "symbol": "MRO", "code": "MRO", "symbol_native": "\u0623.\u0645.\u200F", "decimal_digits": 0 },
    "MUR": { "symbol": "MUR", "code": "MUR", "symbol_native": "Rs", "decimal_digits": 0 },
    "MWK": { "symbol": "MWK", "code": "MWK", "symbol_native": "MK", "decimal_digits": 2 },
    "MXN": { "symbol": "MXN", "code": "MXN", "symbol_native": "$", "decimal_digits": 2 },
    "MXV": { "symbol": "MXV", "code": "MXV", "symbol_native": "MXV", "decimal_digits": 2 },
    "MYR": { "symbol": "MYR", "code": "MYR", "symbol_native": "RM", "decimal_digits": 2 },
    "MZN": { "symbol": "MZN", "code": "MZN", "symbol_native": "MTn", "decimal_digits": 2 },
    "NAD": { "symbol": "NAD", "code": "NAD", "symbol_native": "$", "decimal_digits": 2 },
    "NGN": { "symbol": "NGN", "code": "NGN", "symbol_native": "\u20A6", "decimal_digits": 2 },
    "NIO": { "symbol": "NIO", "code": "NIO", "symbol_native": "C$", "decimal_digits": 2 },
    "NOK": { "symbol": "NOK", "code": "NOK", "symbol_native": "kr", "decimal_digits": 2 },
    "NPR": { "symbol": "NPR", "code": "NPR", "symbol_native": "नेरू", "decimal_digits": 2 },
    "NZD": { "symbol": "NZD", "code": "NZD", "symbol_native": "$", "decimal_digits": 2 },
    "OMR": { "symbol": "OMR", "code": "OMR", "symbol_native": "\u0631.\u0639.\u200F", "decimal_digits": 3 },
    "PAB": { "symbol": "PAB", "code": "PAB", "symbol_native": "B\/.", "decimal_digits": 2 },
    "PEN": { "symbol": "PEN", "code": "PEN", "symbol_native": "S\/", "decimal_digits": 2 },
    "PGK": { "symbol": "PGK", "code": "PGK", "symbol_native": "K", "decimal_digits": 2 },
    "PHP": { "symbol": "PHP", "code": "PHP", "symbol_native": "\u20B1", "decimal_digits": 2 },
    "PKR": { "symbol": "PKR", "code": "PKR", "symbol_native": "Rs", "decimal_digits": 0 },
    "PLN": { "symbol": "zł", "code": "PLN", "symbol_native": "zł", "decimal_digits": 2 },
    "PYG": { "symbol": "PYG", "code": "PYG", "symbol_native": "Gs.", "decimal_digits": 0 },
    "QAR": { "symbol": "QAR", "code": "QAR", "symbol_native": "\u0631.\u0642.\u200F", "decimal_digits": 2 },
    "RON": { "symbol": "RON", "code": "RON", "symbol_native": "RON", "decimal_digits": 2 },
    "RSD": { "symbol": "RSD", "code": "RSD", "symbol_native": "RSD", "decimal_digits": 0 },
    "RUB": { "symbol": "RUB", "code": "RUB", "symbol_native": "\u20BD", "decimal_digits": 2 },
    "RWF": { "symbol": "RWF", "code": "RWF", "symbol_native": "RF", "decimal_digits": 0 },
    "SAR": { "symbol": "SAR", "code": "SAR", "symbol_native": "\u0631.\u0633.\u200F", "decimal_digits": 2 },
    "SBD": { "symbol": "SBD", "code": "SBD", "symbol_native": "$", "decimal_digits": 2 },
    "SCR": { "symbol": "SCR", "code": "SCR", "symbol_native": "SR", "decimal_digits": 2 },
    "SDG": { "symbol": "SDG", "code": "SDG", "symbol_native": "ج.س.", "decimal_digits": 2 },
    "SEK": { "symbol": "SEK", "code": "SEK", "symbol_native": "kr", "decimal_digits": 2 },
    "SGD": { "symbol": "SGD", "code": "SGD", "symbol_native": "$", "decimal_digits": 2 },
    "SHP": { "symbol": "SHP", "code": "SHP", "symbol_native": "£", "decimal_digits": 2 },
    "SLL": { "symbol": "SLL", "code": "SLL", "symbol_native": "Le", "decimal_digits": 0 },
    "SOS": { "symbol": "SOS", "code": "SOS", "symbol_native": "S", "decimal_digits": 0 },
    "SRD": { "symbol": "SRD", "code": "SRD", "symbol_native": "$", "decimal_digits": 2 },
    "SSP": { "symbol": "SSP", "code": "SSP", "symbol_native": "£", "decimal_digits": 2 },
    "STN": { "symbol": "STN", "code": "STN", "symbol_native": "STN", "decimal_digits": 2 },
    "SYP": { "symbol": "SYP", "code": "SYP", "symbol_native": "\u0644.\u0633.\u200F", "decimal_digits": 0 },
    "SZL": { "symbol": "SZL", "code": "SZL", "symbol_native": "E", "decimal_digits": 2 },
    "THB": { "symbol": "THB", "code": "THB", "symbol_native": "THB", "decimal_digits": 2 },
    "TJS": { "symbol": "TJS", "code": "TJS", "symbol_native": "сом.", "decimal_digits": 2 },
    "TND": { "symbol": "TND", "code": "TND", "symbol_native": "\u062F.\u062A.\u200F", "decimal_digits": 3 },
    "TOP": { "symbol": "TOP", "code": "TOP", "symbol_native": "T$", "decimal_digits": 2 },
    "TRY": { "symbol": "TRY", "code": "TRY", "symbol_native": "\u20BA", "decimal_digits": 2 },
    "TTD": { "symbol": "TTD", "code": "TTD", "symbol_native": "$", "decimal_digits": 2 },
    "TWD": { "symbol": "TWD", "code": "TWD", "symbol_native": "$", "decimal_digits": 2 },
    "TZS": { "symbol": "TZS", "code": "TZS", "symbol_native": "TSh", "decimal_digits": 0 },
    "UAH": { "symbol": "UAH", "code": "UAH", "symbol_native": "\u20B4", "decimal_digits": 2 },
    "UGX": { "symbol": "UGX", "code": "UGX", "symbol_native": "USh", "decimal_digits": 0 },
    "USD": { "symbol": "USD", "code": "USD", "symbol_native": "$", "decimal_digits": 2 },
    "USN": { "symbol": "USN", "code": "USN", "symbol_native": "USN", "decimal_digits": 2 },
    "UYI": { "symbol": "UYI", "code": "UYI", "symbol_native": "UYI", "decimal_digits": 0 },
    "UYU": { "symbol": "UYU", "code": "UYU", "symbol_native": "$", "decimal_digits": 2 },
    "UZS": { "symbol": "UZS", "code": "UZS", "symbol_native": "сўм", "decimal_digits": 0 },
    "VEF": { "symbol": "VEF", "code": "VEF", "symbol_native": "Bs.", "decimal_digits": 2 },
    "VND": { "symbol": "VND", "code": "VND", "symbol_native": "\u20AB", "decimal_digits": 0 },
    "VUV": { "symbol": "VUV", "code": "VUV", "symbol_native": "VT", "decimal_digits": 0 },
    "WST": { "symbol": "WST", "code": "WST", "symbol_native": "WS$", "decimal_digits": 2 },
    "XAF": { "symbol": "FCFA", "code": "XAF", "symbol_native": "FCFA", "decimal_digits": 0 },
    "XCD": { "symbol": "EC$", "code": "XCD", "symbol_native": "$", "decimal_digits": 2 },
    "XOF": { "symbol": "CFA", "code": "XOF", "symbol_native": "CFA", "decimal_digits": 0 },
    "XPF": { "symbol": "CFPF", "code": "XPF", "symbol_native": "FCFP", "decimal_digits": 0 },
    "YER": { "symbol": "YER", "code": "YER", "symbol_native": "\u0631.\u064A.\u200F", "decimal_digits": 0 },
    "ZAR": { "symbol": "ZAR", "code": "ZAR", "symbol_native": "R", "decimal_digits": 2 },
    "ZMW": { "symbol": "ZMW", "code": "ZMW", "symbol_native": "K", "decimal_digits": 2 }
};

var services = {
    getLeadAvailability: getLeadAvailability,
    getProducts: getProducts,
    getSession: getSession,
    getAvailabilityCalendar: getAvailabilityCalendar,
    getPackages: getPackages,
    checkSession: checkSession,
    fetchReservations: fetchReservations,
    downloadReservations: downloadReservations,
    getListOfLoyaltyPrograms: getListOfLoyaltyPrograms,
    getHotels: getHotels,
    getHotelDetails: getHotelDetails,
    getActiveConfiguration: getActiveConfiguration,
    getVIPLevels: getVIPLevels,
    getReservations: getReservations,
    getProfileDuplicates: getProfileDuplicates,
    getProfile: getProfile,
    getPrefixes: getPrefixes,
    getPreferencesList: getPreferencesList,
    getLanguages: getLanguages,
    getCurrencies: getCurrencies,
    getCountriesList: getCountriesList,
    updateProfile: updateProfile,
    deleteProfile: deleteProfile,
    getBlacklistReason: getBlacklistReason,
    getWidgetAvailabilityCalendar: getWidgetAvailabilityCalendar,
    getWidgetHotelDetails: getWidgetHotelDetails,
    getWidgetHotels: getWidgetHotels
};

var utils = {
    fetchData: fetchData
};

export { currencies, environments, services, utils };
//# sourceMappingURL=index.es.js.map
